import getGraphQlClient from '~graphql/getGraphQlClient';
import { DELETE_NECROLOGIO } from '~graphql/queries/necrologi';

export default async function deleteNecrologio(id) {
  const graphQlClient = await getGraphQlClient();

  return graphQlClient.mutate({
    mutation: DELETE_NECROLOGIO,
    variables: { id },
  });
}
